"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = __importDefault(require("@hh.ru/analytics-js"));
/** Клик на кнопку "Ответить" на экране "Не нашли компанию в списке или вас что-то смутило?" */
const userStatusSelectSendWhatConfusedButtonClick = ({ text, ...analyticsParams }) => analytics_js_1.default.sendHHEventButtonClick("user_status_select_send_what_confused", { text, ...analyticsParams });
exports.default = userStatusSelectSendWhatConfusedButtonClick;
